"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Tooltip = void 0;
var _react = _interopRequireDefault(require("react"));
var _styles = require("@mui/material/styles");
var _reactI18next = require("react-i18next");
var _Card = _interopRequireDefault(require("@mui/material/Card"));
var _Typography = _interopRequireDefault(require("@mui/material/Typography"));
var _Table = _interopRequireDefault(require("@mui/material/Table"));
var _TableBody = _interopRequireDefault(require("@mui/material/TableBody"));
var _TableCell = _interopRequireDefault(require("@mui/material/TableCell"));
var _TableContainer = _interopRequireDefault(require("@mui/material/TableContainer"));
var _TableRow = _interopRequireDefault(require("@mui/material/TableRow"));
var _Divider = _interopRequireDefault(require("@mui/material/Divider"));
var Tooltip = function Tooltip(_ref) {
  var active = _ref.active,
    payload = _ref.payload,
    label = _ref.label;
  var _useTranslation = (0, _reactI18next.useTranslation)(),
    t = _useTranslation.t;
  var theme = (0, _styles.useTheme)();
  if (active && payload && payload.length) {
    var data = payload.at(0).payload;
    return /*#__PURE__*/_react.default.createElement(_TableContainer.default, {
      className: "custom-tooltip",
      component: _Card.default
    }, /*#__PURE__*/_react.default.createElement(_Typography.default, {
      sx: {
        textAlign: 'left',
        color: theme.palette.text.primary,
        fontWeight: 'bold',
        pl: 2
      }
    }, " ", t('intlDateShort', {
      val: new Date(label)
    }), " "), /*#__PURE__*/_react.default.createElement(_Divider.default, null), /*#__PURE__*/_react.default.createElement(_Table.default, {
      size: "small"
    }, /*#__PURE__*/_react.default.createElement(_TableBody.default, null, /*#__PURE__*/_react.default.createElement(_TableRow.default, null, /*#__PURE__*/_react.default.createElement(_TableCell.default, {
      align: "left",
      sx: {
        fontWeight: 'bold',
        color: theme.palette.text.secondary
      }
    }, " ", t('maximum'), " "), /*#__PURE__*/_react.default.createElement(_TableCell.default, {
      align: "right"
    }, " ", t('intlCurrencyShort', {
      val: data.maximum
    }))), /*#__PURE__*/_react.default.createElement(_TableRow.default, null, /*#__PURE__*/_react.default.createElement(_TableCell.default, {
      align: "left",
      sx: {
        fontWeight: 'bold',
        color: theme.palette.text.secondary
      }
    }, " ", t('minimum'), " "), /*#__PURE__*/_react.default.createElement(_TableCell.default, {
      align: "right"
    }, " ", t('intlCurrencyShort', {
      val: data.minimum
    }), " ")), /*#__PURE__*/_react.default.createElement(_TableRow.default, null, /*#__PURE__*/_react.default.createElement(_TableCell.default, {
      align: "left",
      sx: {
        fontWeight: 'bold',
        color: theme.palette.text.secondary
      }
    }, " ", t('modal'), " "), /*#__PURE__*/_react.default.createElement(_TableCell.default, {
      align: "right"
    }, "  ", t('intlCurrencyShort', {
      val: data.modal
    }), " ")), /*#__PURE__*/_react.default.createElement(_TableRow.default, null, /*#__PURE__*/_react.default.createElement(_TableCell.default, {
      align: "left",
      sx: {
        fontWeight: 'bold',
        color: theme.palette.text.secondary
      }
    }, " ", t('arrivals'), " "), /*#__PURE__*/_react.default.createElement(_TableCell.default, {
      align: "right"
    }, "  ", data.arrivals, " ")))));
  }
};
exports.Tooltip = Tooltip;